<template>
  <section class="dark-graph">
    <div class="container">
      <div class="tab-graph">
        <div
          class="tbGraph-btn d-flex justify-content-between align-items-center"
        >
          <div>
            <h3>{{ tabTitle }}</h3>
          </div>
          <div>
            <ul class="nav nav-pills" id="pills-tab" role="tablist">
              <li class="nav-item" role="presentation">
                <button
                  style="cursor: pointer"
                  class="nav-link"
                  :class="{ active: activeTab === 'power' }"
                  @click="handleTabClick('power', 'POWER Curve')"
                  id="pills-home-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-home"
                  type="button"
                  role="tab"
                  aria-controls="pills-home"
                  :aria-selected="activeTab === 'power'"
                >
                  POWER
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  style="cursor: pointer"
                  class="nav-link"
                  :class="{ active: activeTab === 'wkg' }"
                  @click="handleTabClick('wkg', 'POWER CURVE (W/KG)')"
                  id="pills-profile-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-profile"
                  type="button"
                  role="tab"
                  aria-controls="pills-profile"
                  :aria-selected="activeTab === 'wkg'"
                >
                  W/KG
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div class="tab-content" id="pills-tabContent">
          <div
            class="tab-pane fade"
            :class="{ 'show active': activeTab === 'power' }"
            id="pills-home"
            role="tabpanel"
            aria-labelledby="pills-home-tab"
          >
            <div class="graph-wrpr-box">
              <LineChartGenerator
                v-if="activeTab === 'power'"
                :chart-options="chartOptions"
                :chart-data="chartDataDefault"
                :key="'power-chart'"
              />
            </div>
            <div class="checkBoxes d-flex justify-content-center">
              <label> <i class="fa-solid fa-circle"></i> All TIME </label>

              <label v-if="firstGraphDate">
                <i class="fa-solid fa-circle txtClrlightRed"></i>
                {{ firstGraphDate }}
              </label>

              <label v-if="secondGraphDate">
                <i class="fa-solid fa-circle txtClrSkyBlue"></i>
                {{ secondGraphDate }}
              </label>
            </div>
          </div>
          <div
            class="tab-pane fade"
            :class="{ 'show active': activeTab === 'wkg' }"
            id="pills-profile"
            role="tabpanel"
            aria-labelledby="pills-profile-tab"
          >
            <div class="graph-wrpr-box">
              <LineChartGenerator
                v-if="activeTab === 'wkg'"
                :chart-options="chartOptionsWeightPerKg"
                :chart-data="chartDataWeightPerKg"
                :key="'wkg-chart'"
              />
            </div>
            <div class="checkBoxes d-flex justify-content-center">
              <label> <i class="fa-solid fa-circle"></i> All TIME </label>

              <label v-if="firstGraphDate">
                <i class="fa-solid fa-circle txtClrlightRed"></i>
                {{ firstGraphDate }}
              </label>

              <label v-if="secondGraphDate">
                <i class="fa-solid fa-circle txtClrSkyBlue"></i>
                {{ secondGraphDate }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Line as LineChartGenerator } from "vue-chartjs/legacy";

export default {
  name: "PowerCurves",
  components: {
    LineChartGenerator,
  },
  props: {
    tabTitle: {
      type: String,
      required: true,
    },
    chartDataDefault: {
      type: Object,
      required: true,
    },
    chartOptions: {
      type: Object,
      required: true,
    },
    chartDataWeightPerKg: {
      type: Object,
      required: true,
    },
    chartOptionsWeightPerKg: {
      type: Object,
      required: true,
    },
    firstGraphDate: {
      type: String,
      default: "",
    },
    secondGraphDate: {
      type: String,
      default: "",
    },
  },
  emits: ["tab-selected"],
  data() {
    return {
      activeTab: "power",
    };
  },
  mounted() {
    // Initialize with power tab active
    this.activeTab = "power";
  },
  methods: {
    handleTabClick(tabName, title) {
      this.activeTab = tabName;
      this.$emit("tab-selected", title);

      // Force chart re-render after tab switch
      this.$nextTick(() => {
        window.dispatchEvent(new Event("resize"));
      });
    },
  },
};
</script>
